import { AUTH_API } from "./authApi";

function qs(params = {}) {
    const q = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === "") continue;
        q.set(key, String(value));
    }

    const s = q.toString();
    return s ? `?${s}` : "";
}

async function publicFetch(path) {
    const url = `${AUTH_API}${path}`;

    const res = await fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    });

    const text = await res.text();

    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        const preview = String(text || "").slice(0, 180);

        throw new Error(
            `API liefert kein JSON. HTTP ${res.status}. Aufgerufen wurde: ${url}. Antwort beginnt mit: ${preview}`
        );
    }

    if (!res.ok || data?.ok === false) {
        throw new Error(data?.detail || data?.error || data?.message || `HTTP ${res.status}`);
    }

    return data;
}

export async function fetchGt3xPublicCases({
                                               raceId = "",
                                               caseType = "incidents",
                                               seasonKey = "",
                                           } = {}) {
    const cleanSeasonKey = String(seasonKey || "").trim();

    // Wichtig:
    // Für die aktive Saison NICHT season_key=active senden.
    // Der ReKo-Public-Endpoint soll dann selbst die aktive Season auflösen.
    const seasonKeyForApi =
        cleanSeasonKey && cleanSeasonKey.toLowerCase() !== "active"
            ? cleanSeasonKey
            : "";

    return publicFetch(
        `/api/reko/public/gt3x/cases${qs({
            race_id: raceId,
            case_type: caseType,
            season_key: seasonKeyForApi,
        })}`
    );
}

// Optional noch kurz drinlassen, falls irgendwo noch alter Name importiert wird.
// Kann später entfernt werden, wenn App/Incidents komplett umgestellt sind.
export const fetchGt3xCasesTesting = fetchGt3xPublicCases;